import { lazy } from 'react';

import usePdfPtsCoveredGraph from './usePdfPtsCoveredGraph';

const PtArrivalsPtsCovered = lazy(() => import('./PtArrivalsPtsCovered'));
const PtArrivalsPtsCoveredGraph = lazy(
  () => import('./PtArrivalsPtsCoveredGraph')
);

export {
  PtArrivalsPtsCovered,
  PtArrivalsPtsCoveredGraph,
  usePdfPtsCoveredGraph,
};
